export default "__VITE_ASSET__D2Y9OVPK__"